/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { EvidenceExportGipAltReportMutationRequest, EvidenceExportGipAltReportMutationResponse, EvidenceExportGipAltReportPathParams, EvidenceExportGipAltReport400, EvidenceExportGipAltReport404 } from "../models/EvidenceExportGipAltReport";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { evidenceExportGipAltReport } from "../axios/evidenceExportGipAltReport";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const evidenceExportGipAltReportMutationKey = () => ["audit-reports-api", { url: '/reports/gip-alt/report/:id/evidence-export' }] as const

export type EvidenceExportGipAltReportMutationKey = ReturnType<typeof evidenceExportGipAltReportMutationKey>

export function evidenceExportGipAltReportMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EvidenceExportGipAltReportMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = evidenceExportGipAltReportMutationKey()
        return mutationOptions<EvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<EvidenceExportGipAltReport400 | EvidenceExportGipAltReport404>, {id: EvidenceExportGipAltReportPathParams["id"], data: EvidenceExportGipAltReportMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return evidenceExportGipAltReport(id, data, config)
          },
        })

}

/**
 * @summary Start evidence export
 * {@link /reports/gip-alt/report/:id/evidence-export}
 */
export function useEvidenceExportGipAltReport<TContext>(options: 
{
  mutation?: UseMutationOptions<EvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<EvidenceExportGipAltReport400 | EvidenceExportGipAltReport404>, {id: EvidenceExportGipAltReportPathParams["id"], data: EvidenceExportGipAltReportMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EvidenceExportGipAltReportMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? evidenceExportGipAltReportMutationKey()

          const baseOptions = evidenceExportGipAltReportMutationOptions(config) as UseMutationOptions<EvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<EvidenceExportGipAltReport400 | EvidenceExportGipAltReport404>, {id: EvidenceExportGipAltReportPathParams["id"], data: EvidenceExportGipAltReportMutationRequest}, TContext>
          

          return useMutation<EvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<EvidenceExportGipAltReport400 | EvidenceExportGipAltReport404>, {id: EvidenceExportGipAltReportPathParams["id"], data: EvidenceExportGipAltReportMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<EvidenceExportGipAltReport400 | EvidenceExportGipAltReport404>, {id: EvidenceExportGipAltReportPathParams["id"], data: EvidenceExportGipAltReportMutationRequest}, TContext>
      
}